import { styled } from '@mui/system';

import Tooltip from 'ui/Tooltip';

export const RoundBox = styled('div')<{ $roundColor: string }>`
  cursor: default;
  width: 44px;
  height: 44px;
  border-radius: 99px;
  background-color: ${(props) => props.$roundColor};
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export const MarkerTooltip = styled(Tooltip)`
  & .MuiTooltip-tooltip {
    background-color: ${({ theme }) => theme.palette.common.white};
    color: ${({ theme }) => theme.palette.primary.dark};
  }
`;
